import { render, staticRenderFns } from "./EditACL.vue?vue&type=template&id=c89ff912&scoped=true"
import script from "./EditACL.vue?vue&type=script&lang=js"
export * from "./EditACL.vue?vue&type=script&lang=js"
import style0 from "./EditACL.vue?vue&type=style&index=0&id=c89ff912&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89ff912",
  null
  
)

export default component.exports